import script from "./DialogOptionsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogOptionsCard.vue?vue&type=script&setup=true&lang=js"

import "./DialogOptionsCard.vue?vue&type=style&index=0&id=53a38e5d&lang=scss&scoped=true"

import exportComponent from "D:\\vsts-agent\\_work\\53\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53a38e5d"]])

export default __exports__